import React from "react";
import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";
import { MdDeliveryDining, MdOutlineCancel } from "react-icons/md";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiProgress2Fill } from "react-icons/ri";
import { SlCheck } from "react-icons/sl";
import { useSelector } from "react-redux";
import moment from "moment";
import DropdownMenubar from "../../../../Components/Menubar/DropdownMenubar";
import { Badge } from "primereact/badge";
import OrderApi from "../../../../App/api/order.apis";
import { toast } from "react-toastify";
import { Accordion, AccordionTab } from "primereact/accordion";
import PrintInvoice from "./PrintInvoice";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";
// import "../../../../Assets/css/tailwind.css";

function OrderDetails({ deliveryAddress,handleCloseOrderModal, orderDetails, orderData }) {
  const { theme } = useSelector((state) => state.theme);

  const handleAction=async(data, action)=>{
    if (action.vendor_action) {
      const payload={
        orderId:data._id,
        vendor_action:action.vendor_action
      }
      try {
      const res = await  OrderApi.updateFoodOrders(payload)  
      toast.success(`${res?.data?.data?.delivery_status}`)
      handleCloseOrderModal();
      } catch (error) {
        console.log(error);
        
      }
    }
    
  }

  return (
    <div
      className={`py-6 px-4 mx-auto rounded-lg shadow-md transition-all duration-300 ease-in-out ${
        theme === "light"
          ? "bg-white text-gray-800"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6 border-b border-gray-300 pb-4">
        <div className="flex flex-col gap-2 justify-between">
          <div className=" p-3 border border-gray-100 bg-gray-100 rounded-lg shadow-sm">
            <p className="text-sm font-medium">
              Invoice #{orderData?.order_id} -{" "}
              {moment(deliveryAddress?.createdAt).format("DD MMM YYYY hh:mm A")}
            </p>
            <p>
              Payment status:{" "}
              <span
                className={`text-sm ${
                  orderData?.payment_status === "UNPAID"
                    ? "text-red-500"
                    : "text-green-500"
                }`}
              >
                {orderData?.payment_status}
              </span>
            </p>
            <p className="text-sm text-gray-500">
              Payment type {orderData?.pay_type}
            </p>
          </div>
          <div
            className={`${
              orderData?.delivery_status === "CANCELLED"
                ? "bg-red-500"
                : "bg-blue-900"
            } text-white px-4 py-2 rounded-md text-sm text-center shadow`}
          >
            <p>{orderData?.delivery_status}</p>
            <p>
              {moment(deliveryAddress?.updatedAt).format("DD MMM YYYY hh:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {deliveryAddress?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="flex gap-2 text-gray-500 text-xl hover:text-blue-900 transition duration-300">
            <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
            {deliveryAddress?.phone_number ?? "N/A"}
          </p>
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue-900" />
          <p className="text-gray-700">
            {deliveryAddress?.flat_no ?? "N/A"},{" "}
            {deliveryAddress?.landmark ?? "N/A"},
            {deliveryAddress?.street ?? "N/A"},{" "}
            {deliveryAddress?.pin_code ?? "N/A"}
          </p>
        </div>
      </div>

      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Vendor Details</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {orderData?.vendor_details?.first_name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p className="flex gap-2 text-gray-500 text-xl hover:text-blue-900 transition duration-300">
          <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
            {orderData?.vendor_details?.phone_number ?? "N/A"}
          </p>
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <CiLocationOn className="text-3xl text-blue-900" />
          <p className="text-gray-700">
            {orderData?.vendor_details?.address ?? "N/A"}
          </p>
        </div>
      </div>

      <hr className="my-4 border-gray-300" />

      {orderDetails.map((details, index) => (        
        <div         
          className="mb-6 p-4 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
        >
          <div className="flex justify-between items-center">
            <h3 className="font-bold text-xl text-gray-800">
              {details?.product?.name ?? "Unnamed Product"}
            </h3>
            <div>
            <GetVendorInfo row={orderData} handleAction={handleAction}/>
          </div>
          </div>

          <div className="flex justify-between items-center mb-4 mt-2">
            <p className="text-blue-900 font-semibold">
              {details?.quantity ?? 0} Item
              {(details?.quantity ?? 0) > 1 ? "s" : ""}
            </p>
          </div>
         <div className="flex justify-between items-center">
         <p className="text-green-600 text-lg font-semibold">
              {formattedAmount(Number(details?.net_total?.$numberDecimal ?? 0))}
          </p>
          <OrderStatus row={orderData}/>
         </div>
          <hr className="mt-2 border-gray-300" />
          <PrintInvoice details={details} deliveryDetails={deliveryAddress} vendorDetails={orderData?.vendor_details} index={index}/>
          {/* <Accordion multiple activeIndex={[index]}>
            <AccordionTab header={<p className="text-lg font-bold my-4">Invoice</p>}>
              <TaxData
                key={`${index}t`}
                item={details?.product?.product_details}
              />
              <DeliveryFeeData key={`${index}d`} data={details?.delivery_fee} />
            </AccordionTab>
          </Accordion> */}
        </div>         
      ))}
    </div>
  );
}

export default OrderDetails;


const OrderStatus=({row}) => {
  console.log('row',row);
  
  let severity;
  if (row.delivery_status === "DELIVERED") {
    severity = "success";
  } else if (row.delivery_status === "WAITING") {
    severity = "warning";
  } else if (row.delivery_status === "ACCEPTED") {
    severity = "success";
  } else if (row.delivery_status === "CANCELLED") {
    severity = "danger";
  }

  return row.delivery_status ? (
    <Badge        
      className="w-[9rem]"
      severity={severity}
      value={row.delivery_status}
    />
  ) : null;
}


const DD = ({MenuItems}) => {
  return (
    <div className="w-[1.5rem] btn pl-2 h-[1.5rem] rounded-sm flex justify-center items-center">

      <DropdownMenubar
        menuItem={[
          {
            label: "Action",
            items: MenuItems,
          },
        ]}
        />
    </div>
  );
};
const GetVendorInfo = ({row,handleAction}) => {
  // console.log("Get Status",row);
  
  const status = row?.delivery_status;
  switch (status) {
    case "WAITING":
      return <DD MenuItems={
        [
          {
            label: "ACCEPT",
            icon: <SlCheck style={{color:" rgb(15 61 100)"}} />,
            command: () => {
              // console.log("Accept", row);
              handleAction && handleAction(row,{vendor_action:"ACCEPT"})
            },
          },
          {
            label: "REJECT",
            icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
            command: () => {
              // console.log("Reject", row);
              handleAction&&handleAction(row,{vendor_action:"REJECT"})
            },
          },
        ]
      }/>   
    case "REJECTED":
      return <>Rejected</>;
    case "ACCEPTED":
      return <DD MenuItems={[
        {
          label: "ASSIGN",
          icon: <RiProgress2Fill style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("ASSIGN", row);
            handleAction&&handleAction(row,{vendor_action:"ASSIGN"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL", row);
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "PREPARED":
      return <DD MenuItems={[
        {
          label: "READY",
          icon: <IoCheckmarkDoneCircleOutline style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept", row);
            handleAction&&handleAction(row,{vendor_action:"READY"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL", row);
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "READY":
      return <DD MenuItems={[
        {
          label: "ASSIGN",
          icon: <MdDeliveryDining style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept");
            handleAction&&handleAction(row,{vendor_action:"ASSIGN"})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL");
            handleAction&&handleAction(row,{vendor_action:"CANCEL"})
          },
        },
      ]}/>;
    case "ASSIGNED":
      return <DD MenuItems={[
        {
          label: "ASSIGN",
          icon: <MdDeliveryDining style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("Accept");
            handleAction&&handleAction(row,{vendor_action:'ASSIGN'})
          },
        },
        {
          label: "CANCEL",
          icon: <MdOutlineCancel style={{color:" rgb(15 61 100)"}}/>,
          command: () => {
            // console.log("CANCEL");
            handleAction&&handleAction(row,{vendor_action:'CANCEL'})
          },
        },
      ]}/>;
    default:
      return <></>;
  }
};